import { mutationTree } from "typed-vuex";
import { Ranking } from "@wl/types/lib/types/ranking/ranking";
import state, { RankingState } from "./state";

/**
 * Ranking module mutations.
 */
const mutations = mutationTree(state, {
    /**
     * Sets the global ranking.
     *
     * @param {TabState} state Ranking state
     * @param {Ranking[]} ranking Ranking to set
     */
    setGlobal(state: RankingState, ranking: Ranking[] | undefined): void {
        if (!ranking) return;

        state.global = ranking;
    },

    /**
     * Sets local ranking.
     *
     * @param {TabState} state Ranking state
     * @param {Ranking[]} ranking Ranking to set
     */
    setLocal(state: RankingState, ranking: Ranking[] | undefined): void {
        if (!ranking) return;

        state.local = ranking;
    },

    /**
     * Clears the ranking module state.
     *
     * @param {RankingState} state Ranking state
     */
    clear(state: RankingState): void {
        state.global = [];
        state.local = [];
    },
});

export default mutations;
